import { Outlet, useLocation } from "react-router-dom";
import { SidebarNew } from "./SidebarNew";
import { NavbarNew } from "./NavBarNew";
import { useEffect, useMemo, useState } from "react";
import { useUser } from "@/hooks/useUser";
import { useTranslation } from "react-i18next";
// import useCurruntLocationQuary from "@/api/query/useCurruntLocationQuary";
import useRibbonsListQuery from "@/api/query/useRibbonMessageQuery";
import { darkenColor } from "../views/custom/gantt/src/helpers/colorMixer";
import { getTimeRemaining } from "@/helperFuntions/timeRemaining";
import { PlanTypeEnumSchema, UserRoleEnumValue } from "@backend/src/schemas/enums";
import useProjectQuery from "@/api/query/useProjectQuery";
function Layout() {
  const [open, setOpen] = useState(true);
  const {  t } = useTranslation();
  const { user } = useUser();
  // const locationQuary = useCurruntLocationQuary();
  const projectQuery = useProjectQuery(false);

  // useEffect(() => {
  //   if (user) {
  //     i18n.changeLanguage(
  //       "fr"
  //       // locationQuary.data?.data.data?.country === "CA" || locationQuary.data?.data.data?.country === "FR" ? "fr" : "en"
  //     );
  //   }
  // }, [locationQuary, user]);

  const ribbonsListQuery = useRibbonsListQuery();
  const [showRibbon, setShowRibbon] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const location = useLocation();
  
  useEffect(() => {
    setShowRibbon(setShow());
  }, [ribbonsListQuery.isRefetching, dismissed, user]);

  const setShow = () => {
    if (user && user.userOrganisation[0]?.role == UserRoleEnumValue.ADMINISTRATOR) {
      if (
        user.subscription?.planType == PlanTypeEnumSchema.ENTERPRISE ||
        user.subscription?.planType == PlanTypeEnumSchema.BUSINESS
      ) {
        return false;
      }
      if (
        !projectQuery.data?.data.data?.length &&
        location.pathname == "/projects"
      ) {
        return false;
      }

      if (!ribbonsListQuery.data?.data?.data?.[0]?.active) {
        return false;
      }
      if (ribbonsListQuery.data?.data?.data?.[0]) {
        const today = new Date();
        const ribbon = ribbonsListQuery.data.data.data[0];

        const ribbonStartDate = new Date(ribbon.startDate);
        const ribbonExpiry = new Date(ribbon.validUntil);

        today.setHours(0, 0, 0, 0);
        ribbonStartDate.setHours(0, 0, 0, 0);
        ribbonExpiry.setHours(0, 0, 0, 0);

        const isTodayStart = today.getTime() === ribbonStartDate.getTime();
        const isTodayExpiry = today.getTime() === ribbonExpiry.getTime();
        const isWithinRange = today >= ribbonStartDate && today <= ribbonExpiry;

        return (isWithinRange || isTodayStart || isTodayExpiry) && !dismissed;
      }
    }
    return false;
  };

  const [time, setTime] = useState<{ [key: string]: string }>();
  const validUntil = ribbonsListQuery.data?.data.data[0]?.validUntil ?? "";

  useEffect(() => {
    const interval = setInterval(() => {
      if (validUntil) {
        const remainingTime = getTimeRemaining(validUntil);
        setTime(remainingTime);
      }
    }, 1000);

    return () => clearInterval(interval); // Cleanup to avoid memory leaks
  }, [validUntil]); // Depend on validUntil instead of ribbonsListQuery.isRefetching

  const memoizedRibbon = useMemo(() => {
    return (
      <div className="w-[85%]">
        <div
          className="ribbon w-full z-50 relative flex justify-center gap-2"
          style={
            {
              "--ribbon-color":
                ribbonsListQuery.data?.data.data[0]?.backgroundColor,
              "--ribbon-color-dark": darkenColor(validUntil),
            } as React.CSSProperties
          }
        >
          <div
            className="text-center h-fit my-auto"
            dangerouslySetInnerHTML={{
              __html: ribbonsListQuery.data?.data.data[0]?.message ?? "",
            }}
          />
          <div className="text-white w-40 flex gap-2 items-center">
            {time &&
              Object.keys(time).map((t) => {
                return (
                  <div className="">
                    <div className="text-lg font-semibold">{time[t] ?? 0}</div>
                    <div className="text-[0.5rem] font-semibold tracking-widest">
                      {t}
                    </div>
                  </div>
                );
              })}
          </div>
          <div
            className="text-xs text-right absolute right-1 bottom-1 text-white !font-bold underline cursor-pointer"
            onClick={() => {
              localStorage.setItem("ribbon", validUntil);
              setShowRibbon(false);
              setDismissed(true);
            }}
          >
            {t("dismiss")}
          </div>
        </div>
      </div>
    );
  }, [time, validUntil]);

  const useShowPopup = () => {
    const pathSegments = location.pathname.split("/").filter(Boolean);
  
    const notAllowRibbon = ["plans", "checkout","organisation"]; 
    const allowOnlyDynamic = ["organisation"];
  
    if (allowOnlyDynamic.includes(pathSegments[0]) && pathSegments.length > 1) {
      return true;
    }
    if (notAllowRibbon.includes(pathSegments[0])) {
      return false;
    }
  
  
    return true;
  };
  return (
    <>
      <div className="flex h-screen w-screen overflow-hidden overflow-x-hidden ">
        <SidebarNew isShow={open} setOpen={(e) => setOpen(e)} />
        <div
          className={`flex flex-col transition-all duration-300  h-full ${
            open ? "min-w-[80%] w-full" : "min-w-[99%]"
          } ${
            location.pathname == "/projects" && showRibbon
              ? " h-[calc(100vh-6.5rem)]"
              : " "
          }`}
        >
          <NavbarNew isShow={open} setOpen={(e) => setOpen(e)} />
          {useShowPopup() && showRibbon && (
            <div
              className={`transform transition-all duration-500 p-2 bg-slate-100 w-full relative flex justify-center items-center h-full  ${
                showRibbon ? "max-h-[110px] opacity-100 " : "max-h-0 opacity-0"
              }`}
            >
              {memoizedRibbon}
            </div>
          )}
          <Outlet />
        </div>
      </div>
    </>
  );
}

export default Layout;
